import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { isNativeApp } from "@/lib/native/platform";
import { initNativePush, setNativePushDeepLinkHandler } from "@/lib/native/push";

/**
 * Registers the native device with APNs/FCM once a Supabase session exists and
 * routes notification taps to the Desk deep link.
 *
 * Renders nothing and does nothing at all on the web build.
 */
export const NativePushBoot = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNativeApp()) return;

    setNativePushDeepLinkHandler((url) => {
      try {
        if (/^https?:\/\//i.test(url)) {
          const parsed = new URL(url);
          if (parsed.origin === window.location.origin) {
            navigate(parsed.pathname + parsed.search + parsed.hash);
          } else {
            window.location.assign(url);
          }
          return;
        }
        navigate(url);
      } catch {
        navigate("/admin");
      }
    });

    let cancelled = false;

    const register = () => {
      if (cancelled) return;
      void initNativePush();
    };

    void supabase.auth.getSession().then(({ data }) => {
      if (data.session) register();
    });

    const { data: sub } = supabase.auth.onAuthStateChange((event, session) => {
      if (session && (event === "SIGNED_IN" || event === "TOKEN_REFRESHED" || event === "INITIAL_SESSION")) {
        register();
      }
    });

    return () => {
      cancelled = true;
      setNativePushDeepLinkHandler(null);
      sub.subscription.unsubscribe();
    };
  }, [navigate]);

  return null;
};

export default NativePushBoot;
